import React, { useEffect, useRef, useState } from 'react';
import { ThumbnailContainer, staticSize } from './styled';
export const Thumbnail = ({ thumbnail, progress = 0, isVisible, className = '', playerInstance, getTimelineElement, }) => {
    const [selectedPosition, setSelectedPosition] = useState({
        x: 0,
        y: 0,
    });
    const [left, setLeft] = useState(0);
    const scale = staticSize.height / thumbnail.height;
    useEffect(() => {
        if (Number.isNaN(progress))
            return;
        const finalWidth = staticSize.width / scale;
        const finalHeight = staticSize.height / scale;
        const xDiff = (thumbnail.width - finalWidth) / 2;
        const yDiff = (thumbnail.height - finalHeight) / 2;
        const position = {
            x: thumbnail.x + xDiff,
            y: thumbnail.y + yDiff,
        };
        setSelectedPosition(position);
    }, [progress, thumbnail]);
    const thumbnailRef = useRef(null);
    useEffect(() => {
        if (isVisible && thumbnailRef.current) {
            const thumbnailPositions = thumbnailRef.current.getBoundingClientRect();
            const playerContainerPositions = playerInstance.parentElement.getBoundingClientRect();
            const timeLineDimensions = getTimelineElement().current.getBoundingClientRect();
            const timelineFromPlayerLeft = timeLineDimensions.left - playerContainerPositions.left;
            const timelineFromPlayerRight = playerContainerPositions.right - timeLineDimensions.right;
            const timelineWidth = timeLineDimensions.width;
            const minDistance = thumbnailPositions.width / 2;
            const progressLeft = (timeLineDimensions.width * progress) / 100;
            if (progressLeft + timelineFromPlayerLeft < minDistance) {
                setLeft(minDistance - timelineFromPlayerLeft);
            }
            else if (timelineFromPlayerRight + (timelineWidth - progressLeft) < minDistance) {
                setLeft(timelineWidth + timelineFromPlayerRight - minDistance);
            }
            else {
                setLeft(progressLeft);
            }
        }
    }, [progress, thumbnail, isVisible, getTimelineElement]);
    return (React.createElement(ThumbnailContainer, { ref: thumbnailRef, "data-test": "Thumbnail-Container", className: `${className} Thumbnail-Container`, scale: scale, backgroundImage: thumbnail.url, thumbnailPosition: selectedPosition, left, isVisible }));
};
Thumbnail.displayName = 'Thumbnail';
//# sourceMappingURL=index.js.map